import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table'
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule } from '@angular/material/card';
import { DatePipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSortModule } from '@angular/material/sort';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartUnchecked } from '@fortawesome/free-regular-svg-icons';


import {
	DateAdapter, MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
} from '@angular/material/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { Config } from '../environments/config';

// figure out auth!!
// import { AuthInterceptor } from './auth/auth.interceptor';
// import { AppRoutingModule } from './app.routes';
// import { AuthGuardService } from './auth/auth-guard.service';
// import { SkipAuthGuard } from 'auth/skip-auth-guard.service';
// import { AuthService } from './auth/auth.service';

// modules

import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { TopnavComponent } from './components/topnav/topnav.component';
import { FooterComponent } from './components/footer/footer.component';

import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { AuthorizeComponent } from './components/authorize/authorize.component';


import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalComponent } from './components/modal/modal.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NoResultsComponent } from './components/no-results/no-results.component';
import { MatTabsModule } from '@angular/material/tabs';
import { PageNotFoundComponent } from './pages/page-not-found-component/page-not-found-component.component';
import { MatExpansionModule } from '@angular/material/expansion';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { StatusBubbleComponent } from './components/status-bubble/status-bubble/status-bubble.component';
import { TranslatePipe } from './components/translate/translate.pipe';
import { TranslationService } from './services/translation.service';
import { MatFormField } from '@angular/material/form-field';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ApplicationVersionService } from './services/application-version.service';
import { VideoStoreLoginComponent } from './pages/video-store-login/video-store-login.component';
import { VideoStoreLoginLegacyComponent } from './pages/video-store-login-legacy/video-store-login-legacy.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';



const MY_DATE_FORMAT = {
	parse: {
		dateInput: 'DD/MM/yyyy', // this is how your date will be parsed from Input
	},
	display: {
		dateInput: 'DD/MM/yyyy', // this is how your date will get displayed on the Input
		monthYearLabel: 'MMMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};

@NgModule({ declarations: [
        AppComponent,
        DashboardComponent,
        FooterComponent,
        AuthorizeComponent,
        ModalComponent,
        NoResultsComponent,
        PageNotFoundComponent,
        StatusBubbleComponent,
        TranslatePipe,
        VideoStoreLoginComponent,
        VideoStoreLoginLegacyComponent,
        LanguageSelectorComponent,
        ContactUsComponent,
        VideoPlayerComponent,
        TermsAndConditionsComponent,
        PrivacyPolicyComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatSortModule,
        MatToolbarModule,
        MatPaginatorModule,
        MatTooltipModule,
        TopnavComponent,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        BrowserAnimationsModule,
        NgIf,
        MatCardModule,
        MatDatepickerModule,
        MatSelectModule,
        MatRadioModule,
        MatNativeDateModule,
        NgxMaterialTimepickerModule,
        MatDialogModule,
        DatePipe,
        MatSnackBarModule,
        MatAutocompleteModule,
        MatTabsModule,
        MatExpansionModule,
        //  CKEditorModule,
        ClipboardModule,
        MatSelectModule,
        NgxDropzoneModule,
        MatCheckboxModule,
        FroalaEditorModule,
        FroalaViewModule,
        FontAwesomeModule,
        NgxExtendedPdfViewerModule], providers: [
        DatePipe,
        MatSnackBarModule,
        TranslationService,
        ApplicationVersionService,
        TranslatePipe,
        // figure out auth!!
        // {
        // 	provide: HTTP_INTERCEPTORS,
        // 	useClass: AuthInterceptor,
        // 	multi: true
        // },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [Config],
            multi: true,
        },
        // {
        // 	provide: APP_BASE_HREF,
        // 	useValue: '/',
        // },
        Config,
        // { provide: NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { hideRequiredMarker: true, floatLabel: 'always', appearance: 'outline' } },
        provideHttpClient(withInterceptorsFromDi()),
    ] })

export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faHeart,
      faHeartUnchecked
    );
  }
}

export function initializeApp(config: Config) {
	return (): Promise<any> => {
		return config.Init();
	};
}
